/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to draw your signature by hand instead?`)
};

const es_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres dibujar tu firma a mano en lugar de eso?`)
};

const de_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie Ihre Signatur lieber von Hand zeichnen?`)
};

const nl_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wilt u uw handtekening liever met de hand tekenen?`)
};

const fr_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous dessiner votre signature à la main à la place?`)
};

const it_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi disegnare la tua firma a mano invece?`)
};

const pt_br2_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer desenhar sua assinatura manualmente?`)
};

const pt_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer desenhar a sua assinatura manualmente?`)
};

const ja_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代わりに手書きで署名を描きたいですか?`)
};

const zh_sig_type_draw_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想改为手工绘制您的签名吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_draw_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_draw_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_draw_hint", locale)
	if (locale === "en") return en_sig_type_draw_hint(inputs)
	if (locale === "es") return es_sig_type_draw_hint(inputs)
	if (locale === "de") return de_sig_type_draw_hint(inputs)
	if (locale === "nl") return nl_sig_type_draw_hint(inputs)
	if (locale === "fr") return fr_sig_type_draw_hint(inputs)
	if (locale === "it") return it_sig_type_draw_hint(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_draw_hint(inputs)
	if (locale === "pt") return pt_sig_type_draw_hint(inputs)
	if (locale === "ja") return ja_sig_type_draw_hint(inputs)
	return zh_sig_type_draw_hint(inputs)
};